import { Dict } from '~/src/types'

export const generatePath = (pathname: string, params: Dict<string | null | undefined>) => 
	Object.entries(params).reduce((acc, [k, v]) => acc.replace(`[${k}]`, v ?? '') ,pathname)